import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import cx from "classnames";
import React, { Component } from "react";
import { connect } from "react-redux";
import { topNavStyles } from "../styles/topBarStyle";
import { MyPATDialog, MyPATCollapse } from "../../common";
import { Tabs } from "../types/Constants";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import { ContentRequest } from "../types/ContentRequest";
import _ from "lodash";
import { format } from "date-fns";

interface RequestInfoProps extends WithStyles<typeof topNavStyles> {
  requestData: ContentRequest;
  isRequested:boolean
}

interface RequestInfoState {
  expandedFilter: boolean;
}

class RequestInfo extends Component<RequestInfoProps, RequestInfoState> {
  constructor(props: RequestInfoProps) {
    super(props);
    this.state = {
      expandedFilter: true,
    };
  }

  render() {
    const { classes, requestData,isRequested } = this.props;

    return (
      <>
        {/* <MyPATCollapse
          title={
            <>
              Request Info
              <CustomInfoIcon
                infoDialogContentType="Request Info"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Request Info"
                imageURL="/assets/svg/infoIcon/createQuestion/math.svg"
                dialogPara="This tool helps user to generate input with proper text and mathematical equations from image inserted inside Easy Maths feature. You can find more details in the Help section-> Editor Manual."
                details="Click to know more"
                toolTipDirection="top"
              />
            </>
          }
        > */}
          <Grid container>
            <Grid item xs={12} className={classes.infoContainer}>
              <Typography>
                <span>
                  <strong>Status: </strong>
                </span>
                <span>{_.capitalize(requestData.status)}</span>
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.infoContainer}>
              <Typography>
                <span>
                  <strong>Request ID: </strong>
                </span>
                <span>
                  <b>{requestData.requestId}</b>
                </span>
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.infoContainer}>
              <Typography>
                <span>
                  <strong>{isRequested?"Requested On:":"Created On:"} </strong>
                </span>
                <span>
                  {requestData.createdAt &&
                    format(new Date(requestData.createdAt), "dd MMM yyyy")}
                </span>
              </Typography>
            </Grid>
          </Grid>
        {/* </MyPATCollapse> */}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({});

export default connect(
  mapStateToProps
  // @ts-ignore
)(withStyles(topNavStyles)(RequestInfo));
